import('./bootstrap.js').catch((error) => {
	console.error(error);
	// if (window.performance.getEntriesByType('navigation')[0].type !== 'reload') {
	// 	import('@pages/Login/Steps/LoginFailed').then((res) => {
	// 		if (error.name === 'ChunkLoadError') {
	// 			res.renderChunkError({
	// 				error: {
	// 					code: error.name,
	// 					message: error.message,
	// 				},
	// 			});
	// 		}
	// 	});
	// }
});
